import axios from 'axios';

// Create axios instance
const axiosInstance = axios.create();

const handleAuthFailure = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');

  if (typeof window !== 'undefined') {
    const currentPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    if (window.location.pathname !== '/login') {
      sessionStorage.setItem('postLoginRedirectPath', currentPath || '/dashboard');
      window.location.href = '/login';
    }
  }
};

// Add request interceptor to include auth token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    config.headers = config.headers || {};
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      handleAuthFailure();
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
